export default {
    encoding: [
        {
            name: 'featureId',
            type: '[string]',
            desc:
                'Specify the dataSource field that should be used to identify each element in the Choropleth svg, where the element has been tagged with an id field.',
            isRequired: 'false',
        },
        {
            name: 'value',
            type: '[number]',
            desc: 'Specify the dataSource field that indicates the values for the features.',
            isRequired: 'false',
        },
        {
            name: 'fill',
            type: '[string]',
            desc:
                'Specify the dataSource field that should be used to set the svg fill attribute of identified elements',
            isRequired: 'false',
        },
    ],
    events: [],
};
